import React from "react"

import {
	Button,
	Chip,
	Tooltip,
	Typography,
} from "@mui/material"

import {
	t,
	Trans,
} from "@lingui/macro"
import { Link } from "react-router-dom"

import { getChipProps } from "components/commons/tickets-chip-props"
import CircleIcon from '@mui/icons-material/Circle';


const defaultColumnDefinition: any = {
	field: "",
	headerName: "",
	headerAlign: "left",
	align: "left",
}
const getTicketsTableColumns = (): any => {
	return [
		{
			...defaultColumnDefinition,
			field: "updates",
			flex: 0.1,
			sortable: false,
			renderCell: (params: any) => (
				<>
					{ params.row.updates &&
					<Tooltip title={"1 nuovo aggiornamento"} placement="top" arrow>
						<CircleIcon sx={{ color: "red", fontSize: 8 }} />
					</Tooltip> }
				</>
			),
		},
		{
			...defaultColumnDefinition,
			field: "ticketNumber",
			headerName: t({
				id: "ttc-ticket-number",
				message: "Numero ticket",
			}),
			flex: 1.6,
			renderCell: (params: any) => {
				return <Typography>{params.row.ticketNumber} </Typography>
			},
			sortable: false
		},
		{
			...defaultColumnDefinition,
			field: "status",
			headerName: t({
				id: "ttc-status",
				message: "Stato"
			}),
			flex: 2,
			renderCell: (params: any) => {
				return <Chip {...getChipProps(params.row.status)} />
			},
			sortable: false
		},
		{
			...defaultColumnDefinition,
			field: "date",
			headerName: t({
				id: "ttc-date",
				message: "Data"
			}),
			flex: 1.5,
			sortable: false,
		},
		{
			...defaultColumnDefinition,
			field: "button",
			flex: 2,
			sortable: false,
			renderCell: (params: { row: any }) => (
				<Link key={`contract-${params.row.id}`} to={`/error`}>
					<Button
						variant="contained"
						size="small"
						disableElevation
						sx={{
							textTransform: 'none',
							backgroundColor: 'secondary.main',
							color: 'white',
						}}>
						<Typography>
							<Trans id="tickets-table.view-comunicaztions">
								Apri
							</Trans>
						</Typography>
					</Button>
				</Link>

			),
		},
	]
}

export default getTicketsTableColumns
